export const isTwoSituationExercise = (exercise) => Boolean(
  exercise?.two_situations
  || (
    exercise?.evaluation_type === "COMPETENCES"
    && ["PHYSIQUE", "CHIMIE"].includes(exercise?.matiere)
    && Number(exercise?.points) >= 16
  )
);
